// extracted by mini-css-extract-plugin
export default {"header":"AppBar_header__6MZ3-"};